export default {
	takeNowButton: "Take Now",
	noAssessmentLabel: "assessment not taken",
};
